import { render, staticRenderFns } from "./AlertStack.vue?vue&type=template&id=c499b8f4&scoped=true"
import script from "./AlertStack.vue?vue&type=script&lang=js"
export * from "./AlertStack.vue?vue&type=script&lang=js"
import style0 from "./AlertStack.vue?vue&type=style&index=0&id=c499b8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c499b8f4",
  null
  
)

export default component.exports